import { render, staticRenderFns } from "./PopupLead.vue?vue&type=template&id=5b46c4c0&scoped=true&lang=pug"
import script from "./PopupLead.vue?vue&type=script&lang=js"
export * from "./PopupLead.vue?vue&type=script&lang=js"
import style0 from "./PopupLead.vue?vue&type=style&index=0&id=5b46c4c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b46c4c0",
  null
  
)

export default component.exports